import cls from 'classnames';

import SvgIcon from '../SvgIcon';

import useStyles from './styles';
import IInlineNotificationProps from './types';

export default function InlineNotification({
  backgroundColor = 'var(--x-status-success)',
  className,
  children,
  iconName,
  iconUrl,
  onClose,
}: IInlineNotificationProps) {
  const classes = useStyles();

  return (
    <div className={cls(classes.root, className)} style={{ backgroundColor }}>
      <div className={classes.container}>
        {(iconName || iconUrl) && (
          <SvgIcon
            className={cls(classes.icon, classes.iconDefault)}
            name={iconName}
            url={iconUrl}
          ></SvgIcon>
        )}
        <span>{children}</span>
      </div>
      <SvgIcon
        className={cls(classes.icon, classes.iconClose)}
        name="close-gen"
        onClick={onClose}
      />
    </div>
  );
}
